module.exports = __webpack_public_path__ + "static/retail_provisional-e5ea517656a125ac9dce89b04ecf8b75.png";